import React from 'react';
import { Redirect } from 'react-router';
import PostDetail from '../../AnalyticsDashboard/PostDetail';
import { InstagramHashtagPostDetails } from './__generated__/InstagramHashtagPostDetails';

interface TemplateProps {
  closeModal: () => void;
  data: InstagramHashtagPostDetails | undefined;
}

const Template = (props: TemplateProps) => {
  const { data, closeModal } = props;

  if (!data || !data.instagramHashtagPostDetails) {
    return <Redirect to="/404" />;
  }

  const {
    instagramHashtagPostDetails: {
      avatarUrl,
      instagramAccountName,
      content,
      commentList,
      postImageUrl,
      postUrl,
      analysis,
      sentiment
    }
  } = data;

  return (
    <PostDetail
      avatarUrl={avatarUrl}
      closeModal={closeModal}
      accountName={instagramAccountName}
      followers={null}
      content={content}
      commentList={commentList || []}
      postImageUrl={postImageUrl}
      engagement={{
        postUrl,
        analysis,
        sentiment,
        storyData: null,
        hasViewColumn: true
      }}
      hideFollowersCount={true}
    />
  );
};

export default Template;
